export enum FeatureFlags {
  RobinhoodServiceEnabled = 'robinhood-service-enabled',
  FlowIdByAction = 'tools-flow-id-by-action',
  ShouldCreateTaskAsLive = 'tools-should-create-task-as-live',
  ShouldUseQueuePrioritization = 'tools-should-use-queue-prioritization',
  ShouldUseNewSanctionsService = 'tools-should-use-new-sanctions-service',
  ShouldShowProhibitedIndustryWords = 'tools-should-show-prohibited-industry-words',
  ShouldUseManualDecisionAPI = 'tools-should-use-manual-decision-api',
  ShouldRunIncidentManagementService = 'tools-should-run-incident-management-service',
  ShouldCalculateIncidentManagementService = 'tools-should-calculate-incident-management-service',
  ShouldShowSubscriptionTimeline = 'tools-should-show-subscription-timeline',
  ShouldAllowSwitchFirmToSmb = 'tools-should-allow-switch-firm-to-smb',
  ShouldDisplayMultihitFeature = 'should-display-multihit-feature',
  ShouldWriteMultihitFeature = 'should-write-multihit-feature',
  ShouldRequeueTasksAfterReceivedFiles = 'should-requeue-tasks-after-received-files',
  ShouldUpdateKycDataViaApAPI = 'tools-should-update-kyc-data-via-ap-api',
  ShouldEnableRfiForOrg = 'tools-should-enable-rfi-for-org',
  ShouldDisplayRiskyIndicators = 'should-display-risky-indicators',
  ShouldGetPaymentFeaturesFromRiskApi = 'tools-get-payment-features-from-risk-api',
  SherlockAllowOtherEddComplianceRejectionLabel = 'sherlock-allow-other-edd-compliance-rejection-label',
  ShouldShowEntityViewer = 'tools-should-show-entity-viewer',
  ShouldDisplayNewMmFeatures = 'tools-should-display-new-mm-features',
  ShouldHidePphTabs = 'tools-should-hide-pph-tabs',
  UseShiftManagerForShiftCreation = 'tools-use-shift-manager-for-shift-creation',
  UseZendeskWebhookOverEventBridge = 'tools-use-zendesk-webhook-over-event-bridge',
  ShouldDisplayAgentSuggestions = 'risk-should-display-agent-suggestions',
  ShouldDisplayDmLinkingIndication = 'tools-should-display-dm-linking-indication',
  EnableMultihitV1 = 'tools-enable-multihit-v1',
  ShouldUseNewFileMetadataManagement = 'tools-should-use-new-file-metadata-management',
  ToolsRfiConfirmedPartnerConfig = 'tools-rfi-confirmed-partner-config',
  ToolsShouldUseKycNewStatuses = 'tools-should-use-kyc-new-statuses',
  ShouldCreateLimitationTasks = 'tools-should-create-limitation-tasks',
  ShouldPreventCreateEddTaskOnCrrCalculated = 'tools-should-prevent-create-edd-task-on-crr-calculated',
  ToolsShouldDisplayAtoAgentResponse = 'tools-should-display-ato-agent-response',
  ToolsShouldDisplayCashAdvancedAgentResponse = 'tools-should-display-cash-advanced-agent-response',
  ToolsShouldDisplaySfAgentResponse = 'tools-should-display-sf-agent-response',
  ShouldProcessAtoFraudAutomation = 'tools-should-process-ato-fraud-automation',
  SherlockEnableOrganizationLeanStrategyManage = 'sherlock-enable-organization-lean-strategy-manage',
  SherlockEnableCsomStrategyManage = 'sherlock-enable-csom-strategy',
  ToolsShouldDisplayLimitations = 'tools-should-display-limitations',
  ToolsShouldManageOdeLimitations = 'tools-should-manage-ode-limitations',
  ReconServiceShouldShowCheckReconcileFloatingButton = 'recon-service-should-show-check-reconcile-floating-button',
  ToolsShouldDisplayDMCreatorEmail = 'tools-should-display-dm-creator-email',
  ShouldDisplayUserEventTab = 'tools-should-display-user-event-tab',
  MosEgressEmailXeroDomain = 'mos-egress-email-xero-domain'
}
